import styled from 'styled-components';

import { Spacing } from '../../styles/units';

import { Button } from '../../styles/shared.styles';

export const Row = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${Spacing.medium};
`;

export const SwitchButton = styled(Button)`
    background-color: #fff;
    border-color: transparent;
    color: #3059f0;
    cursor: pointer;

    &:hover {
        color: #2046d1;
        background-color: #fff;
        border-color: transparent;
    }
`;
